import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { isCrmIntegrationChatAllowedForUser } from '@pages/Admin/CRM/utils/crmIntegrationAccess'
import { useCrmIntegrationChatAvailability } from '@/hooks/useCrmIntegrationChatAvailability'

/** Доступ текущего пользователя к CRM-интеграционным чатам (док, списки, unread). */
export const useCrmIntegrationChatUserAccess = (): boolean => {
  const profile = useSelector(selectProfile)
  const { isLoading, connectedIntegrations } = useCrmIntegrationChatAvailability()

  return useMemo(() => {
    if (isLoading) return false
    return isCrmIntegrationChatAllowedForUser(profile, connectedIntegrations)
  }, [connectedIntegrations, isLoading, profile])
}
